module.exports = __webpack_public_path__ + "static/media/arrow-small.e633a8cf.svg";